// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { string } from 'prop-types'
import styled from 'styled-components'

export const Icon = styled.i`
  margin-bottom: -.5em;
  margin-left: -.5em;
  margin-top: -.5em;
  transform: scale(1) translate3d(0, 0, 0);
  transition: transform .3s ease;

  &:hover {
    transform: scale(1.2) translate3d(0, 0, 0);
  }
`

const OpenInNewTab = ({ idRoot, newPath }) => {
  const handleClick = useCallback(e => {
    e.stopPropagation()

    // NOTE - this is assuming hash routing
    const newUrl = `${window.location.origin}/#${newPath}`
    window.open(newUrl, '_blank')
  }, [newPath])

  return (
    <Icon
      className={'fa-stack fa fa-lg'}
      data-label={'open-in-new-tab'}
      id={`${idRoot}-open-in-new-tab`}
      onClick={handleClick}
      title={'Open this path\'s details in a new tab.'}>
      <i className={'text-white fa fa-circle fa-stack-1x'} />
      <i className={`text-orange fa fa-stack-1x fa-plus-circle`} />
    </Icon>
  )
}

OpenInNewTab.propTypes = {
  idRoot: string.isRequired,
  newPath: string.isRequired,
}

export default OpenInNewTab
